export default () => window.location.host.split('.')[0];
